<div class="wrap" *ngIf="todaysDeliveries$ | async as todaysDeliveries">
  <app-delivery-for-date
    [items]="todaysDeliveries"
    (confirmationProcessRequested)="onConfirmationProcessRequested($event)"
  ></app-delivery-for-date>

  <div
    class="no-items-hint"
    *ngIf="todaysDeliveries && $any(todaysDeliveries)?.length === 0"
  >
    {{ "@pages.todaysDeliveries.noItemsHint" | translate }}
  </div>
</div>

<div class="app-spinner-container" *ngIf="(todaysDeliveries$ | async) === null">
  <ion-spinner class="app-spinner"></ion-spinner>
</div>
